import React from 'react';
import BookReaderScreen from './BookReaderScreen';

/**
 * Legacy InsightDetailScreen - now delegates to unified BookReaderScreen
 * Kept for backwards compatibility with existing navigation
 * 
 * This thin wrapper allows existing navigation code to work without changes.
 * All params are passed through to BookReaderScreen which handles:
 * - Pre-loaded insights (insights + book)
 * - Insight IDs to fetch (insightIds)
 * - Mixed insights collections (isMixedInsights)
 */

const InsightDetailScreen: React.FC = () => {
  return <BookReaderScreen />;
};

export default InsightDetailScreen; 
